import { useState, useEffect } from 'react';
import { conditionalApiRequest, API_CONFIG } from '../config/api';
import { Product } from './useFeaturedProducts';

export const useNewArrivals = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchNewArrivals = async () => {
      try {
        setLoading(true);
        const data = await conditionalApiRequest<any>(API_CONFIG.ENDPOINTS.PRODUCTS_NEW_ARRIVALS_COLLECTION);
        setProducts(data?.data?.results || data?.results || data?.products || []);
        setError(null);
      } catch (err) {
        setError('Failed to fetch new arrivals');
      } finally {
        setLoading(false);
      }
    };

    fetchNewArrivals();
  }, []);

  return { products, loading, error };
};